import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import HeaderBanner from "../../Components/HeaderBanner/HeaderBanner";
import InstagramSlider from "../../Components/IGSection/IGSection";
import "./gallarypage.css";
import { imgDocs } from "../../gallaryData";
import FadeInWhenVisible from "../../Utilities/FadeInWhenVisible";

const SWIPE_THRESHOLD = 50;

export default function GallaryPage() {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [touchStartX, setTouchStartX] = useState(null);

  const isOpen = selectedIndex !== null;

  const handleClick = (e) => {
    if (e.target.classList.contains("backdrop")) {
      setSelectedIndex(null);
    }
  };

  const showPrev = () => {
    setSelectedIndex((prev) => (prev - 1 + imgDocs.length) % imgDocs.length);
  };

  const showNext = () => {
    setSelectedIndex((prev) => (prev + 1) % imgDocs.length);
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const deltaX = e.changedTouches[0].clientX - touchStartX;
    if (deltaX > SWIPE_THRESHOLD) {
      showPrev();
    } else if (deltaX < -SWIPE_THRESHOLD) {
      showNext();
    }
    setTouchStartX(null);
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") setSelectedIndex(null);
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "ArrowRight") showNext();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <div>
      <HeaderBanner title="Gallary" currentPath="Gallary" />
      <FadeInWhenVisible delay={0.2}>
        <div className="gallerypage">
          <h6 className="small-header">Gallary</h6>
          <h3>Explore Our Gallary</h3>
          <div className="img-grid">
            {imgDocs &&
              imgDocs.map((imgDoc, index) => (
                <motion.div
                  className="img-wrap"
                  key={imgDoc.id ?? index}
                  layout
                  whileHover={{ opacity: 1 }}
                  onClick={() => setSelectedIndex(index)}
                >
                  <motion.img
                    src={imgDoc.url}
                    alt="uploaded pic"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1 }}
                  />
                </motion.div>
              ))}
          </div>

          {isOpen && (
            <motion.div
              className="backdrop"
              onClick={handleClick}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <button
                type="button"
                className="backdrop-close"
                aria-label="Close"
                onClick={() => setSelectedIndex(null)}
              >
                &times;
              </button>

              <button
                type="button"
                className="backdrop-nav backdrop-prev"
                aria-label="Previous image"
                onClick={(e) => {
                  e.stopPropagation();
                  showPrev();
                }}
              >
                &#8249;
              </button>

              <motion.img
                key={selectedIndex}
                src={imgDocs[selectedIndex].url}
                alt="enlarged pic"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              />

              <button
                type="button"
                className="backdrop-nav backdrop-next"
                aria-label="Next image"
                onClick={(e) => {
                  e.stopPropagation();
                  showNext();
                }}
              >
                &#8250;
              </button>
            </motion.div>
          )}
        </div>
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <InstagramSlider />
      </FadeInWhenVisible>
    </div>
  );
}
